import PhotoEditor from "./components/PhotoEditor/PhotoEditor";

function App() {
  return (
     <PhotoEditor />
  );
}

export default App;
